import { render, staticRenderFns } from "./dingdan_mendian.vue?vue&type=template&id=9a38eab8&"
import script from "./dingdan_mendian.vue?vue&type=script&lang=js&"
export * from "./dingdan_mendian.vue?vue&type=script&lang=js&"
import style0 from "./dingdan_mendian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports